module.exports = __webpack_public_path__ + "img/horizontal_3_2_6005.4c50e682.png";